/**
 * WordPress Media Modal Filters
 * Adds type filtering capability to the WordPress media modal
 * Using vanilla JavaScript (no jQuery dependency)
 */
(function() {
    'use strict';
    
    // Function to initialize our filters when wp is available
    function initMediaFilters() {
        if (typeof window.wp === 'undefined' || 
            typeof window.wp.media === 'undefined' || 
            typeof window.wp.media.view === 'undefined') {
            // If WordPress media is not ready yet, wait and try again
            setTimeout(initMediaFilters, 100);
            return;
        }
        
        // Store original functions to extend
        var originalMediaFrame = wp.media.view.MediaFrame.Select;
        var originalAttachmentsBrowser = wp.media.view.AttachmentsBrowser;
        
        // Extend the AttachmentsBrowser to add our filters
        wp.media.view.AttachmentsBrowser = wp.media.view.AttachmentsBrowser.extend({
            createToolbar: function() {
                // Call the original function
                originalAttachmentsBrowser.prototype.createToolbar.apply(this, arguments);
                
                // Add our custom filter
                this.toolbar.set('mediaTypeFilter', new wp.media.view.AttachmentFilters.MediaType({
                    controller: this.controller,
                    model: this.collection.props,
                    priority: 80
                }).render());
            }
        });
        
        // Create a custom filter control
        wp.media.view.AttachmentFilters.MediaType = wp.media.view.AttachmentFilters.extend({
            id: 'media-attachment-type-filter',
            
            createFilters: function() {
                var filters = {};
                
                // Use our predefined filters
                if (typeof TFG_MediaFilters !== 'undefined' && TFG_MediaFilters.filters) {
                    Object.keys(TFG_MediaFilters.filters).forEach(function(value) {
                        var label = TFG_MediaFilters.filters[value];
                        filters[value] = {
                            text: label,
                            props: {
                                // Clear the old filter params
                                media_type: value === 'all' ? null : value,
                                post_mime_type: value === 'application/pdf' ? value : null,
                                // Update the search term to match this filter
                                type: value === 'all' ? null : value
                            },
                            priority: 10
                        };
                    });
                } else {
                    // Fallback if our filters aren't available
                    filters.all = {
                        text: 'All media items',
                        props: {
                            media_type: null,
                            post_mime_type: null,
                            type: null
                        },
                        priority: 10
                    };
                    
                    filters.image = {
                        text: 'Images',
                        props: {
                            media_type: 'image',
                            post_mime_type: null,
                            type: 'image'
                        },
                        priority: 20
                    };
                    
                    filters.audio = {
                        text: 'Audio',
                        props: {
                            media_type: 'audio',
                            post_mime_type: null,
                            type: 'audio'
                        },
                        priority: 30
                    };
                    
                    filters.video = {
                        text: 'Video',
                        props: {
                            media_type: 'video',
                            post_mime_type: null,
                            type: 'video'
                        },
                        priority: 40
                    };
                    
                    // Add PDF filter
                    filters.pdf = {
                        text: 'PDFs',
                        props: {
                            media_type: null,
                            post_mime_type: 'application/pdf',
                            type: 'application/pdf'
                        },
                        priority: 50
                    };
                    
                    // Add Documents filter
                    filters.documents = {
                        text: 'Documents',
                        props: {
                            media_type: 'document',
                            post_mime_type: null,
                            type: 'document'
                        },
                        priority: 60
                    };
                    
                    // Add Spreadsheets filter
                    filters.spreadsheets = {
                        text: 'Spreadsheets',
                        props: {
                            media_type: 'spreadsheet',
                            post_mime_type: null,
                            type: 'spreadsheet'
                        },
                        priority: 70
                    };
                    
                    // Add Presentations filter
                    filters.presentations = {
                        text: 'Presentations',
                        props: {
                            media_type: 'presentation',
                            post_mime_type: null,
                            type: 'presentation'
                        },
                        priority: 80
                    };
                    
                    // Add Archives filter
                    filters.archives = {
                        text: 'Archives',
                        props: {
                            media_type: 'archive',
                            post_mime_type: null,
                            type: 'archive'
                        },
                        priority: 90
                    };
                    
                    // Add Unattached filter
                    filters.unattached = {
                        text: 'Unattached',
                        props: {
                            media_type: null,
                            post_mime_type: null,
                            type: null,
                            uploadedTo: 0
                        },
                        priority: 100
                    };
                }
                
                this.filters = filters;
            }
        });
        
        // Add custom CSS for the filter
        var style = document.createElement('style');
        style.textContent = '#media-attachment-type-filter { float: left; min-width: 120px; margin-right: 2rem; }';
        document.head.appendChild(style);
    }
    
    // Start initialization
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initMediaFilters();
        });
    } else {
        initMediaFilters();
    }
})();